var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-window-manager-tool" },
    [
      _c(
        "Tooltip",
        {
          attrs: {
            title: _vm.$t("chat.layouts.chat") + " (Ctrl + 1)",
            color: "#22272d",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-window-manager-tool-item",
              class: { active: _vm.activeView === "chat" },
              on: {
                click: function ($event) {
                  return _vm.setActiveView("chat")
                },
              },
            },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("auto_awesome_mosaic"),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Tooltip",
        {
          attrs: {
            title: _vm.$t("chat.layouts.table") + " (Ctrl + 2)",
            color: "#22272d",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-window-manager-tool-item",
              class: { active: _vm.activeView === "list" },
              on: {
                click: function ($event) {
                  return _vm.setActiveView("list")
                },
              },
            },
            [_c("div", { staticClass: "material-icons" }, [_vm._v("list_alt")])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Tooltip",
        {
          attrs: {
            title: _vm.$t("chat.layouts.kanban") + " (Ctrl + 3)",
            color: "#22272d",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-window-manager-tool-item",
              class: { active: _vm.activeView === "kanban" },
              on: {
                click: function ($event) {
                  return _vm.setActiveView("kanban")
                },
              },
            },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("view_kanban"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }